export default "__VITE_ASSET__BOX_tDvq__"